enum StopState {
  Default = "DEFAULT",
  Visited = "VISITED",
  Selected = "SELECTED",
  Gmap = "GMAP",
}

export default StopState;
